<template>
	<template v-if="tier">
		<template v-if="tier === 'reason'">
			<span class="resource-error__label sgnl-paragraph-s-medium">Error:</span>
			<code class="resource-error__message sgnl-paragraph-s-regular">{{ message }}</code>
		</template>
		<FetchErrorBanner
			v-else-if="tier === 'output-fetch'"
			:accessState="bannerAccessState"
			:showViewTask="showViewTask"
			:taskID="taskID"
			@retry="$emit('retry')"
		/>
		<StuckNotice
			v-else
			:message="message"
		/>
	</template>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import FetchErrorBanner from "@/components/Common/FetchErrorBanner.vue";
import StuckNotice from "@/components/Common/StuckNotice.vue";
import { RemoteAccessState } from "@/types/general";
import { ResourceError, ResourceErrorTier } from "@/js/utilities";

export default defineComponent({
	name: "ResourceErrorDisplay",
	components: { FetchErrorBanner, StuckNotice },
	emits: ["retry"],
	props: {
		view: { type: Object as PropType<ResourceError | null>, default: null },
		showViewTask: { type: Boolean, default: false },
		taskID: { type: String, default: undefined },
	},
	computed: {
		tier(): ResourceErrorTier | null {
			return this.view?.tier ?? null;
		},
		message(): string {
			return this.view?.message ?? "";
		},
		bannerAccessState(): RemoteAccessState {
			return {
				loading: this.view?.loading ?? false,
				error: true,
				message: this.view?.message ?? "",
				retryable: this.view?.retryable ?? false,
			};
		},
	},
});
</script>

<style scoped>
.resource-error__label {
	color: var(--sgnl-default-secondary-text);
	white-space: nowrap;
}

.resource-error__message {
	color: var(--sgnl-alert-error-text);
}
</style>
